import { Injectable } from '@angular/core'
import moment from 'moment-mini'

import { EmployeeBooking } from './employee-booking'

@Injectable()
export class EmployeeBookingSerializer {
  fromJson(json: any): EmployeeBooking {
    const employeeBooking = {
      ...json,
      endDate: moment(json.endDate).add(1, 'minute').toISOString()
    }

    return employeeBooking
  }

  toJson(employeeBooking: EmployeeBooking): any {
    return {
      ...employeeBooking
    }
  }
}
